/*
 * Code generated by maegi. DO NOT EDIT.
 */

import type React from "react";

export const SocialMediaBluesky16 = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={16} height={16} fill="none" viewBox="0 0 16 16" {...props}>
    <path
      fill="currentColor"
      d="M3.468 1.714C5.303 3.132 7.276 6.005 8 7.547c.725-1.542 2.698-4.415 4.532-5.833C13.855.692 16-.1 16 2.418c0 .503-.28 4.224-.444 4.829-.572 2.1-2.653 2.636-4.504 2.312 3.236.566 4.06 2.444 2.281 4.321-3.376 3.566-4.852-.895-5.23-2.037-.07-.21-.103-.308-.103-.225 0-.083-.033.015-.102.225-.379 1.143-1.855 5.603-5.231 2.037-1.778-1.877-.955-3.755 2.28-4.321-1.85.324-3.932-.212-4.503-2.312C.28 6.642 0 2.92 0 2.418 0-.1 2.145.692 3.468 1.714"
    />
  </svg>
);

export const __descriptor_SocialMediaBluesky = {
  name: "SocialMediaBluesky",
  instances: [{ size: 16, Component: SocialMediaBluesky16 }],
} as const;
